import React, { useEffect } from 'react';
import AppContentView from '@crema/core/AppContentView';
import { useAuthUser } from '../../utility/AuthHooks';
import {
  useLayoutActionsContext,
  useLayoutContext,
} from '../../utility/AppContextProvider/LayoutContextProvider';
import AuthWrapper from './AuthWrapper';
import { useUrlSearchParams } from 'use-url-search-params';
import { useSidebarActionsContext } from '../../utility/AppContextProvider/SidebarContextProvider';
import Layouts from './Layouts';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import routesConfig, { routeConfigAdmintools, routesConfigBPKExternal, routesConfigLite } from 'pages/routesConfig';
import { useDispatch } from 'react-redux';
import { onGetCountNotifications } from 'redux/actions/Portal';
import { setModeApp } from 'redux/actions/ModeApp';

const AppLayout = () => {
  const { navStyle, isiPad } = useLayoutContext();
  const { isAuthenticated } = useAuthUser();
  const { updateNavStyle } = useLayoutActionsContext();
  const { updateMenuStyle, setSidebarBgImage } = useSidebarActionsContext();
  const AppLayout = Layouts[navStyle];
  const [params] = useUrlSearchParams();
  const navigation = useNavigate();
  const appMode = useSelector(({ appMode }) => appMode.mode);
  const dispatch = useDispatch()
  const { user } = useAuthUser()

  let menu = JSON.parse(localStorage.getItem('menu'))


  useEffect(() => {
    // if (isiPad) updateNavStyle('mini');
    // else 

    dispatch(onGetCountNotifications())

    if (params.layout) updateNavStyle(params.layout);
    if (params.menuStyle) updateMenuStyle(params.menuStyle);
    if (params.sidebarImage) setSidebarBgImage(true);
  }, [
    params.layout,
    params.menuStyle,
    params.sidebarImage,
    updateNavStyle,
    updateMenuStyle,
    setSidebarBgImage,
  ]);

  useEffect(() => {
    if (user !== null) {
      const isBPKExternal = user.roles_access.includes('BPK_DRIVE_EXTERNAL')
      const isBPKMonitoring = user.roles_access.includes('BPK_MONITORING')
      if (isBPKExternal || isBPKMonitoring) {
        dispatch(setModeApp('bpk-external'))
      }
    }
  }, [user])

  useEffect(() => {
    if (menu === undefined || menu === null) {
      if (appMode === 'admintools') {
        config_copy = _.cloneDeep(routeConfigAdmintools);
        let menu = {
          full: config_copy,
          lite: routesConfigLite,
          type: 'full'
        }
        localStorage.setItem('menu', JSON.stringify(menu))
      } else if (appMode === 'bpk-external') {
        config_copy = _.cloneDeep(routesConfigBPKExternal);
        let menu = {
          full: config_copy,
          lite: routesConfigLite,
          type: 'full'
        }
        localStorage.setItem('menu', JSON.stringify(menu))
      } else if(appMode === 'portal'){
        let temp = {}
        temp = {
          full: routesConfig,
          lite: routesConfigLite,
          type: 'full'
        }
        localStorage.setItem('menu', JSON.stringify(temp))
      }
    } else {
      let temp = {}
      temp = {
        ...menu,
        full: appMode === 'admintools' ? routeConfigAdmintools : appMode === 'bpk-external' ? routesConfigBPKExternal : routesConfig,
      }
      localStorage.setItem('menu', JSON.stringify(temp))
    }
  }, [menu, appMode])

  return (
    <>
      {isAuthenticated ? (
        <AppLayout />
      ) : (
        <AuthWrapper>
          <AppContentView />
        </AuthWrapper>
      )}
    </>
  );
};

export default React.memo(AppLayout);
